import React from 'react';

import './Button.scss';

/**
 * All different kind of button options
 *
 * @type {Object}
 */
const options = {
  'primary': '',
  'secondary': 'au-btn--secondary',
  'tertiary': 'au-btn--tertiary',
};

interface Props {
  label?: string;
  as?: 'primary' | 'secondary' | 'tertiary';
  className?: string;
  type?: 'button' | 'reset' | 'submit';
  dark?: boolean;
  block?: boolean;
  link?: boolean;
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
}

/**
 * DEFAULT
 * The primary button
 *
 */
const Button: React.FC<Props> = ({ children, as = 'primary', dark, type = 'button', block = false, link = false, className = '', ...attributeOptions }) => {
  if (link) {
    return (
      <button
        type={type}
        className={`au-link-btn ${className}`}
        {...attributeOptions}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      type={type}
      className={`au-btn ${className} ${options[as]}${block ? ' au-btn--block' : ''}${dark ? ' au-btn--dark' : ''}`}
      {...attributeOptions}
    >
      {children}
    </button>
  );
};

export default Button;